module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/BKYS01_banner_web.23c4a764.png";